import { AddStripeAccount, getOrgId, OrganizationId, ServiceOrder } from "api";
import { Credentials } from "auth";
import { Organization } from "generated/graphql";
import { Action, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";
import { State } from "redux/state";

export type AddPaymentAccount = "ADD_PAYMENT_ACCOUNT";
export const ADD_PAYMENT_ACCOUNT: AddPaymentAccount = "ADD_PAYMENT_ACCOUNT";
export type AddPaymentAccountEnd = "ADD_PAYMENT_ACCOUNT_END";
export const ADD_PAYMENT_ACCOUNT_END: AddPaymentAccountEnd = "ADD_PAYMENT_ACCOUNT_END";

export interface AddPaymentAccountToOrganizationAction extends Action {
    payload: {
        organizationId: string;
        account: AddStripeAccount | ServiceOrder;
        credentials: Credentials;
    };
    type: AddPaymentAccount;
}

export function addPaymentAccountToOrganization(
    organization: OrganizationId,
    account: AddStripeAccount | ServiceOrder
): ThunkAction<void, State, undefined, AddPaymentAccountToOrganizationAction> {
    return (dispatch: Dispatch<AddPaymentAccountToOrganizationAction>, getState) => {
        const state = getState();
        dispatch(addPaymentAccountWithCredentials(state.auth.credentials, organization, account));
    };
}

function addPaymentAccountWithCredentials(
    credentials: Credentials,
    organization: OrganizationId,
    account: AddStripeAccount | ServiceOrder
): AddPaymentAccountToOrganizationAction {
    return {
        payload: {
            account,
            credentials,
            organizationId: getOrgId(organization)
        },
        type: ADD_PAYMENT_ACCOUNT
    };
}

export interface AddPaymentAccountToOrganizationEndAction extends Action {
    payload: {
        organization?: Organization;
        error?: Error;
    };
    type: AddPaymentAccountEnd;
}

export function addPaymentAccountToOrganizationEnd(
    error: Error,
    organization?: Organization
): AddPaymentAccountToOrganizationEndAction {
    return {
        payload: {
            error,
            organization
        },
        type: ADD_PAYMENT_ACCOUNT_END
    };
}
